export const MembershipInformationCardQuestions = [
    {
        eventQuestionId: 0,
        eventId: 0,
        isMandatoryQuestion: false,
        eventQuestion: "Where applicable, please enter the relevant information:",
        eventQuestionTypeId: 7,
        isFeedbackQuestion: false,
        answers: [],
        isOther: false,
        placeholder: "Where applicable, please enter the relevant information:"
    },
    {
        eventQuestionId: 0,
        eventId: 0,
        isMandatoryQuestion: false,
        eventQuestion: "SGBC Green Mark Accredited Professional (SGBC-GMP) e.g. SG1234 ",
        eventQuestionTypeId: 1,
        isFeedbackQuestion: false,
        answers: [],
        isOther: false,
    },
    {
        eventQuestionId: 0,
        eventId: 0,
        isMandatoryQuestion: false,
        eventQuestion: "Singapore Institute of Landscape Architects (SILA)",
        eventQuestionTypeId: 1,
        isFeedbackQuestion: false,
        answers: [],
        isOther: false,
    },
    {
        eventQuestionId: 0,
        eventId: 0,
        isMandatoryQuestion: false,
        eventQuestion: "Society of Project Managers Singapore (SPM)",
        eventQuestionTypeId: 1,
        isFeedbackQuestion: false,
        answers: [],
        isOther: false,
    },
    {
        eventQuestionId: 0,
        eventId: 0,
        isMandatoryQuestion: false,
        eventQuestion: "Singapore Institute of Architects (SIA) e.g. 1234",
        eventQuestionTypeId: 1,
        isFeedbackQuestion: false,
        answers: [],
        isOther: false,
    },
    {
        eventQuestionId: 0,
        eventId: 0,
        isMandatoryQuestion: false,
        eventQuestion: "Institution of Engineers, Singapore (SCEM) e.g. SCEM-1234",
        eventQuestionTypeId: 1,
        isFeedbackQuestion: false,
        answers: [],
        isOther: false,
    },
    {
        eventQuestionId: 0,
        eventId: 0,
        isMandatoryQuestion: false,
        eventQuestion: "Professional Engineers Board Singapore (PEB) e.g. 1234",
        eventQuestionTypeId: 1,
        isFeedbackQuestion: false,
        answers: [],
        isOther: false,
    },
    {
        eventQuestionId: 0,
        eventId: 0,
        isMandatoryQuestion: false,
        eventQuestion: "Singapore Contractors Association Ltd (SCAL CPAS) e.g. ACP-1234",
        eventQuestionTypeId: 1,
        isFeedbackQuestion: false,
        answers: [],
        isOther: false,
    },
    {
        eventQuestionId: 0,
        eventId: 0,
        isMandatoryQuestion: false,
        eventQuestion: "Singapore International Facility Management Association (SIFMA CFME) e.g. CFME_12345678_123A",
        eventQuestionTypeId: 1,
        isFeedbackQuestion: false,
        answers: [],
        isOther: false,
    },
    {
        eventQuestionId: 0,
        eventId: 0,
        isMandatoryQuestion: false,
        eventQuestion: "Association of Property and Facility Managers (APFM): Please enter your full name.",
        eventQuestionTypeId: 1,
        isFeedbackQuestion: false,
        answers: [],
        isOther: false,
    },
]